module.exports = __webpack_public_path__ + "about-us-b998e096/video-photo-upload-e94c2ba9894422e2ff345dc1e86a872a.svg";